<template>
  <v-btn
    icon
    class="btn-appbar btn-appbar-right user-menu user-info mr-4"
    :class="{'has-background': backgroundColor, 'non-clickable': !isClickable}"
    :style="{backgroundColor: backgroundColor}"
    data-cy="btn-user-menu"
    @click="handleClick">
    <v-icon dense :color="contentColor">fa-light fa-user</v-icon>
    <div class="user-details">
      <span class="user-name" :style="{color: computedNameColor}">{{ userName }}</span>
      <span class="user-email" :style="{color: contentColor}">{{ userEmail }}</span>
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'UserInfoButton',
  props: {
    userName: {
      type: String,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
    contentColor: {
      type: String,
      default: 'white',
    },
    nameColor: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedNameColor() {
      return this.nameColor || this.contentColor
    },
    isClickable() {
      return !!this.$listeners.click
    },
  },
  methods: {
    handleClick() {
      if (this.isClickable) {
        this.$emit('click')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-appbar {
  text-decoration: none !important;
  color: white !important;
  padding: 0 !important;
  border-radius: 100px !important;
  height: 48px !important;
  width: 48px;

  &.user-menu i {
    padding: 20px !important;
    border-radius: 100px;
  }

  &.user-info {
    width: auto !important;
    padding: 0 12px !important;
  }

  &-right {
    & i.v-icon {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
  }

  &.non-clickable {
    cursor: default !important;
    pointer-events: none;

    &::before {
      display: none !important;
    }
  }
}

.user {
  &-details {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: 12px;
  }

  &-name,
  &-email {
    text-transform: initial;
    line-height: 1.3;
    color: inherit;
    max-width: 128px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &-name {
    font-size: 14px;
  }

  &-email {
    font-size: 12px;
  }
}

.btn-appbar.v-btn {
  font-family: 'ProximaNovaSemibold', sans-serif !important;
}
</style>
